import React, { useState } from 'react';
import { Link } from 'gatsby';
import onClickOutside from 'react-onclickoutside';

const clickOutsideConfig = {};

const Dropdown = () => {
  const [ open, setOpen ] = useState(false);
  const toggle = () => setOpen(!open);
  clickOutsideConfig.handleClickOutside = () => () => setOpen(false);

  return (
    <div className={ open ? 'dropdown-wrapper dropdown-wrapper--open header-options__link' : 'dropdown-wrapper header-options__link' }>
      <div
        tabIndex={ 0 }
        className="dropdown-header"
        role="button"
        onKeyPress={ () => toggle(!open) }
        onClick={ () => toggle(!open) }
      >
        Related Projects
      </div>
      { open && (
        <div className="dropdow-options__wrapper">
          <Link to="/projects/european" className="dropdow-options header-options__link">European Projects</Link>
          <Link to="/projects/national-and-regional" className="dropdow-options header-options__link">National and Regional Projects</Link>
        </div>
      ) }
    </div>
  );
};

// build error, see: https://github.com/Pomax/react-onclickoutside/issues/327
Dropdown.prototype = {};

export default onClickOutside(Dropdown, clickOutsideConfig);
